export default "__VITE_ASSET__beFQGaPk__"